<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-company-list'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to Company</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-company-list'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addCompany">Add Company</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add Company</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-input
            type="text"
            name="company name"
            class="field"
            v-model="company.company_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('company name')}"
            placeholder="Enter company name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('company name')"
          >{{ errors.first('company name') }}</div>
          <primary-input
            name="email"
            type="text"
            v-model="company.contact.email"
            v-validate="'required|email'"
            :class="{'input': true, 'is-danger': errors.has('email')}"
            placeholder="elyse_sauer@yahoo.com"
          />
          <div v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</div>
          <primary-select
            type="text"
            name="country"
            v-validate="'required'"
            v-model="company.contact.country_uuid"
            :class="{'input': true, 'is-danger': errors.has('country')}"
            placeholder="Country"
          >
            <option
              v-for="(i, k) in countrys"
              :value="i.country_uuid"
              :key="k"
            >{{i.nice_name ? i.nice_name : i.name}}</option>
          </primary-select>
          <div v-if="errors.has('country')" class="help is-danger">{{ errors.first('country') }}</div>
          <primary-input
            type="text"
            name="zipcode"
            v-model="company.contact.zipcode"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('zipcode')}"
            placeholder="Enter zipcode"
          />
          <div class="help is-danger" v-if="errors.has('zipcode')">{{ errors.first('zipcode') }}</div>
          <primary-input
            type="first name"
            name="first name"
            v-validate="'required'"
            v-model="company.contact.first_name"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter first name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('first name')"
          >{{ errors.first('first name') }}</div>
        </div>
        <div class="col">
          <primary-input
            type="text"
            name="phone"
            v-model="company.contact.phone"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('phone')}"
            placeholder="Enter phone"
          />
          <div v-if="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</div>
          <primary-input
            type="address"
            name="address"
            v-validate="'required'"
            v-model="company.contact.address"
            :class="{'input': true, 'is-danger': errors.has('address')}"
            placeholder="Enter address"
          />
          <div class="help is-danger" v-if="errors.has('address')">{{ errors.first('address') }}</div>
          <div class="buttons-wrapper">
            <primary-input
              type="text"
              name="state"
              class="state"
              v-validate="'required'"
              v-model="company.contact.state"
              :class="{'input': true, 'is-danger': errors.has('state')}"
              placeholder="state"
            ></primary-input>
            <div class="help is-danger" v-if="errors.has('state')">{{ errors.first('state') }}</div>
            <primary-input
              type="city"
              name="city"
              v-validate="'required'"
              v-model="company.contact.city"
              :class="{'input': true, 'is-danger': errors.has('city')}"
              placeholder="Enter city"
            />
            <div class="help is-danger" v-if="errors.has('city')">{{ errors.first('city') }}</div>
          </div>
          <div class="buttons-wrapper">
            <primary-input
              type="text"
              name="credit"
              class="credit"
              v-validate="'required'"
              v-model="company.credit"
              :class="{'input': true, 'is-danger': errors.has('credit')}"
              placeholder="credit"
            />
            <div class="help is-danger" v-if="errors.has('credit')">{{ errors.first('credit') }}</div>
            <primary-select
              type="text"
              name="mode"
              class="mode"
              v-validate="'required'"
              v-model="company.prepay"
              :class="{'input': true, 'is-danger': errors.has('mode')}"
              placeholder="Enter mode"
            >
              <option v-for="(i, k) in mode" :seleted="company.prepay" :value="i" :key="k">{{i}}</option>
            </primary-select>
            <div class="help is-danger" v-if="errors.has('mode')">{{ errors.first('mode') }}</div>
          </div>
          <primary-input
            type="text"
            name="last name"
            v-validate="'required'"
            v-model="company.contact.last_name"
            :class="{'input': true, 'is-danger': errors.has('last  name')}"
            placeholder="Enter last name"
          />
          <div class="help is-danger" v-if="errors.has('last name')">{{ errors.first('last name') }}</div>
        </div>
        <div class="col">
          <p class="pimary-input-title">Change Photo</p>
          <app-dropzone
            @fileAdd="fileAdded($event)"
            @remove="fileRemoved($event)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone")
  },
  data: () => ({
    contactError: null,
    role: ["Admin", "Normal"],
    mode: ["prepay", "postpay"],
    company: {
      company_name: null,
      credit: null,
      contact: {
        email: null,
        city: null,
        first_name: null,
        last_name: null,
        zipcode: null,
        country_uuid: null,
        address: null,
        logo_file_uuid: null
      },
      prepay: null //false
    },
    file: null,
    countrys: []
  }),
  created() {
    this.getCountrys();
  },
  methods: {
    getCountrys() {
      this.$store
        .dispatch("getCountryList", { nice_name: this.countryName })
        .then(async res => {
          console.log("res from comountry", res);
          this.countrys = res.items;
        });
    },
    fileAdded(file) {
      console.log(file);
      if (file.accepted) {
        this.file = file;
      }
    },
    fileRemoved() {
      this.file = null;
      this.company.contact.logo_file_uuid = null
    },
    uploadPhoto: async function() {
      let data = new FormData();

      data.append("file", this.file);
      data.append("belongs_to", "user.logo");
      data.append("public", true);

      return await this.$store.dispatch("UploadFile", data);
    },
    addCompany: async function() {
      const valid = await this.$validator.validate();

      if (valid) {
        try {
          if (this.file) {
            let res = await this.uploadPhoto();

            this.company.contact.logo_file_uuid = res.object_uuid;

            this.$store.commit(
              "setProfilePath",
              `http://88.198.219.62/api_smsc/v1/file/${res.object_uuid}`
            );
          } else {
            delete this.company.contact.logo_file_uuid;
          }

          this.company.prepay = this.company.prepay === "prepay";
        
          await this.$store.dispatch("AddCompany", {
            company: this.company
          });

          this.$snotify.success("Company have been added.", {
            timeout: 6000
          });

          this.$router.push({ name: "reseller-company-list" });
        } catch (err) {
          if (err.errors) {
            this.contactError = err.errors[0].invoice
              ? err.errors[0].invoice
              : null;
            setTimeout(() => {
              this.contactError = null;
            }, 6000);
          } else if(err.response) {
            this.$snotify.error(
              err.response.data.errors
                ? err.response.data.errors
                : err.response.data.error.message, { timeout: 6000 } );
          } else {
            this.$snotify.error(err, {  timeout: 6000 } );
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 140px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    min-height: 475px;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        .buttons-wrapper {
          display: flex;
          align-items: center;
          width: fit-content;
          width: 100%;
          .state {
            margin-right: 10px;
          }
          .credit {
            margin-right: 10px;
          }
        }
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .upload-photo,
        #dropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            pa0dding: 5px;
            img {
              height: 150px;
              width: 150px;
              border-radius: 50px;
            }
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

